import { render, staticRenderFns } from "./GridSocialIcons.vue?vue&type=template&id=0402827c&scoped=true&"
import script from "./GridSocialIcons.vue?vue&type=script&lang=js&"
export * from "./GridSocialIcons.vue?vue&type=script&lang=js&"
import style0 from "./GridSocialIcons.vue?vue&type=style&index=0&id=0402827c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0402827c",
  null
  
)

export default component.exports